import React, { useCallback } from 'react';
import { SerializedSmartLink } from 'fym-common/src/db/serializersTypes';
import { TypedMemo } from '../../common/types';
import { SmartLinkStatsViewRenderer } from './SmartLinkStatsViewRenderer';
import { useFetchSmartLinkStatsQuery } from '../../../redux/api/fymAPI';
import { SMLStatsUnavailable } from '../stats/SMLStatsUnavailable';
import { SmartLinkStatsDays } from '../../../redux/api/fymAPI.types';

interface SmartLinkStatsViewProps {
  smartLink: SerializedSmartLink;
  /** Campaign-only touches, passed down by the manage screen. */
  presaveCount?: number;
  hasCampaign?: boolean;
  emptyChart?: React.ReactNode;
  /** The window to read. Left out, the server uses 14 days. */
  days?: SmartLinkStatsDays;
}

const SmartLinkStatsViewComponent: React.FC<SmartLinkStatsViewProps> = ({
  smartLink,
  presaveCount,
  hasCampaign,
  emptyChart,
  days,
}) => {
  const {
    data: stats,
    error,
    isLoading,
    refetch,
  } = useFetchSmartLinkStatsQuery({
    accountId: smartLink.accountId,
    smartLinkId: smartLink.id,
    days,
  });

  const refetchCallbacked = useCallback(() => {
    refetch().catch(console.log);
  }, [refetch]);

  if (error) {
    return <SMLStatsUnavailable retry={refetchCallbacked} />;
  }

  return (
    <SmartLinkStatsViewRenderer
      isLoading={isLoading}
      stats={stats}
      days={days}
      widgets={smartLink.recentSmartLinkVersion.widgets}
      presaveCount={presaveCount}
      hasCampaign={hasCampaign}
      emptyChart={emptyChart}
      isLive={smartLink.publishedSmartLinkVersion !== null && smartLink.publishedSmartLinkVersion !== undefined}
    />
  );
};

export const SmartLinkStatsView = TypedMemo(SmartLinkStatsViewComponent);
